<section *ngIf="this.currentUrl ==='task-view/:id'">
    <div class="container my-4">
        <div class="d-flex align-items-baseline my-2">
            <div class="user-box" *ngIf="task_id?.to" placement="top" ngbTooltip="assign to">
                <span class="badge bg-light-primary mx-2 my-1" *ngFor="let item of task_id?.to">{{item?.name}}</span>
            </div>
            <span *ngIf="task_id?.priority" class="badge bg-light-info mx-2" placement="top" ngbTooltip="priority">{{task_id?.priority?.displayname}}</span>
            <span *ngIf="task_id?.label" class="badge bg-light-info mx-2" placement="top" ngbTooltip="label">{{task_id?.label?.displayname}}</span>
            <span *ngIf="task_id?.stage" class="badge bg-light-secondary mx-2" placement="top" ngbTooltip="stage">{{task_id?.stage?.displayname}}</span>
            <span *ngIf="task_id?.type_checklist" class="badge bg-light-secondary mx-2" placement="top" ngbTooltip="type checklist">{{task_id?.type_checklist?.displayname}}</span>
            <div *ngIf="task_id?.type_projects"  placement="top" ngbTooltip="type project">
                <span class="badge bg-light-secondary mx-2 my-1" *ngFor="let item of task_id?.type_projects">{{item?.name}}</span>
            </div>
            <div *ngIf="task_id?.status" placement="top" ngbTooltip="status">
                <span class="badge bg-light-success mx-2 my-1" *ngFor="let item of task_id?.status">{{item?.displayname}}</span>
            </div>
            
        </div>
        <div class="my-2">
            <h6>{{task_id?.title}}</h6>
            <p [innerHTML]="task_id?.body" placement="top" ngbTooltip="body"></p>
            <p [innerHTML]="task_id?.notes" placement="top" ngbTooltip="notes"></p>
            <p [innerHTML]="task_id?.admin_notes" placement="top" ngbTooltip="admin notes"></p>
        </div>
        <div class="my-2">

            <div class="mr-2" *ngIf="task_id.due_date!= ''" placement="top" ngbTooltip="due date"><i class="ft-clock mr-1"></i>{{task_id?.due_date | date:'medium'}}</div>
            <div class="mr-2" *ngIf="task_id.working_hours" placement="top" ngbTooltip="working_hours"><i class="ft-clock mr-1"></i>{{task_id?.working_hours}}</div>
            <div class="mr-2" *ngIf="task_id.budget" placement="top" ngbTooltip="budget"><i class="ft-dollar-sign mr-1"></i>{{task_id?.budget}}</div>

            <div class="d-flex my-2">
                <span class="mx-2"><b>Mandatory :</b> {{task_id?.is_mandatory}}</span>
                <span class="mx-2"><b>Schedule :</b> {{task_id?.is_schedule}}</span>

            </div>
            <div class="d-flex my-2">
                <!-- <span *ngIf="task_id?.created_by" placement="top" ngbTooltip="created by" class="badge bg-light-secondary mx-2">{{task_id?.created_by?.name}}</span> -->
                <span *ngIf="task_id?.last_modifiedby" placement="top" ngbTooltip="updated by" class="badge bg-light-secondary mx-2">{{task_id?.last_modifiedby?.name}}</span>
            </div>
            <div class="mr-2" *ngIf="task_id.created_at!= ''" placement="top" ngbTooltip="created date"><i class="ft-clock mr-1"></i>{{task_id?.created_at | date:'medium'}}</div>
        </div>
    </div>
  
</section>

<!-- Candidate view -->

<section *ngIf="this.currentUrl ==='candidate-view/:id'">
    <div class="container my-4">
        <div class="my-2">
            <h4>{{candidate_model?.name}}</h4>
            <p>{{candidate_model?.email}}</p>
            <p>{{candidate_model?.phone}}</p>
            <p>{{candidate_model?.address}}</p>
            <p *ngIf="candidate_model?.jobopening" class="badge bg-light-info">{{candidate_model?.jobopening?.title}}</p>
            <p *ngIf="candidate_model?.tagging" class="badge bg-light-primary">{{candidate_model?.tagging[0]?.displayname}}</p>
            <p [innerHTML]="candidate_model?.notes"></p>
            <p [innerHTML]="candidate_model?.admin_notes"></p>
        </div>
        
    </div>
  
</section>